import Index from '@tunnel-components/@pages/supervision/display/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/display/home/index.ts